import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ProjectsDataService} from '../projects-data.service';
import {ActivatedRoute} from '@angular/router';
import KTWizard from 'src/app/crm/assets/js/components/wizard';
import { KTUtil } from 'src/app/crm/assets/js/components/util';
import {CompanyValuesModel} from '../../../shared/models/companyValues.model';
import {ResponsibilityModel} from '../../../shared/models/responsibility.model';
import {skillRequiredModel} from '../../../shared/models/skillRequired.model';
import {TechnicalTestingModel} from '../../../shared/models/technicalTesting.model';
import {PsychologicalTestingModel} from '../../../shared/models/psychologicalTesting.model';
import {ForeignLanguageModel} from '../../../shared/models/foreignLanguage.model';
import {ChannelsModel} from '../../../shared/models/channels.model';
import {TestsModel} from '../../../shared/models/tests.model';
import {RecruitersModel} from '../../../shared/models/recruiters.model';
import {Select2OptionData} from 'ng-select2';
import {Options} from 'select2';
import {SelectLocationTable} from '../../../../shared/location-select.table';
import {SelectFieldsTable} from '../../../../jobboard/modules/jobs/create-job/select-fields.table';


@Component({
    selector: 'app-view-project',
    templateUrl: './view-project.component.html',
    styleUrls: ['./view-project.component.scss'],
    providers: [SelectLocationTable, SelectFieldsTable]
})
export class ViewProjectComponent implements OnInit {
    @ViewChild('wizard', { static: true }) el: ElementRef;

    projectId: string;
    projectData: any = [];

    submitted = false;
    wizard: any;

    projectLoaded: boolean;

    project: any = [];
    projectUpdated: any = [];

    public clientsOptions: Options;
    public multiSelectOp: Options;
    public singleOptions: Options;

    selectCareerPossibility: Array<Select2OptionData>;
    selectOtherBenefit: Array<Select2OptionData>;
    selectWorkingTools: Array<Select2OptionData>;
    foreignLanguages: any;
    driverLicense: Array<Select2OptionData>;

    clientsMainArray: any = [];
    clientsNameArray: any = [] ;
    clientsNameObject: any = [];

    recruitersMainArray: any = [];
    recruitersNameArray: any = [];
    recruitersDataLoaded: boolean;

    crmUsersMainArray: any = [];
    crmUsersNameArray: any = [];
    crmUsersDataLoaded: boolean;

    companyName: string;
    dataLoaded: boolean;

    selectedRecrut: any = [];


    recruitmentSteps: any = [
        'Atragere candidati / Sourcing',
        'Selectie CVs / Screening',
        'Pretestare',
        'Interviuri ABJ',
        'Teste ABJ',
        'Propunere candidati lista lunga',
        'Acceptare candidati de catre client',
        'Test 1 client',
        'Interviu 1 client',
        'Lista scurta client',
        'Evaluare/test 2 client',
        'Interviu 2 client',
        'Candidat final/top',
        'Ofertare candidat',
        'Raspuns candidat',
        'Negociere pachet',
        'Preaviz candidat',
        'Start job/ start garantie',
        'Intocmire plan de inductie/onbording',
        'Feedback 1 candidat si angajator( dupa 1 sapt de activ)',
        'Evaluare interna ABJ proiect/evaluare  ABJ  si recrutor intern, extern',
        'Evaluare externa ABJ proiect/evaluare ABJ si  recrutor ABJ',
        'Feedback 2 candidat si angajator(mijloc garantie)',
        'Feedback 3 candidat si angajator(final garantie)',
        'Evaluare finala, interna si externa, proiect',
        'Alte aspecte specifice proiectului (txt)'
    ];

    demoContracts: any = [
        {id: "0", text: "0"},
        {id: "1", text: "1"},
        {id: "2", text: "2"},
        {id: "3", text: "3"},
        {id: "4", text: "4"},
        {id: "5", text: "5"}


    ];

    demoFiscalBill: any = [
        0,
        1,
        2,
        3,
        4,
        5,

    ];

    // --- Dropdown for country and city
    countries = this.locationSelect.Countries;
    cities: Array<any> = [];
    changeCountry(country: any) {
        this.cities = this.countries.find((cntry: any) => cntry.name == country.target.value).cities;
    }
    // --- End of dropdown for country and city

    // Declare the form
    public form: {
        companyValues: CompanyValuesModel[],
        responsibility: ResponsibilityModel[],
        skillRequired: skillRequiredModel[],
        technicalTesting: TechnicalTestingModel[],
        psychologicalTesting: PsychologicalTestingModel[],
        foreignLanguage: ForeignLanguageModel[],
        internChannel: ChannelsModel[],
        externChannel: ChannelsModel[],
        internalTechnicalTest: TestsModel[],
        externalTechnicalTest: TestsModel[],
        internalPhysiologicalTest: TestsModel[],
        externalPhysiologicalTest: TestsModel[],
        otherTest: TestsModel[],
        recruiters: RecruitersModel[]

    };

    constructor(private projectsService: ProjectsDataService,
                private route: ActivatedRoute,
                private locationSelect: SelectLocationTable,
                private selectFields: SelectFieldsTable) {
        this.form = {
            companyValues: [],
            responsibility: [],
            skillRequired: [],
            technicalTesting: [],
            psychologicalTesting: [],
            foreignLanguage: [],
            internChannel: [],
            externChannel: [],
            internalTechnicalTest: [],
            externalTechnicalTest: [],
            internalPhysiologicalTest: [],
            externalPhysiologicalTest: [],
            otherTest: [],
            recruiters: []
        };
    }

    ngOnInit(): void {

        this.selectCareerPossibility = this.selectFields.selectCareerPossibility;
        this.selectOtherBenefit = this.selectFields.selectOtherBenefit;
        this.selectWorkingTools = this.selectFields.selectWorkingTools;
        this.foreignLanguages = this.selectFields.languages;
        this.driverLicense = this.selectFields.driveLicense;

        this.clientsOptions = {
            width: '100%',
            multiple: false,
            allowClear: true
        }

        this.singleOptions = {
            width: '100%',
            multiple: false,
            allowClear: true
        }

        this.multiSelectOp = {
            width: '100%',
            multiple: true,
            allowClear: true
        }

        this.route.params.subscribe(params => {
            this.projectId = params['id'];
            this.projectsService.getProject(this.projectId).subscribe(project => {
                this.projectData = project;
                console.log(this.projectData, 'project data')
                let selectedSimilarRecrut = [];
                this.projectData.responsibleIdForSimilarProjects.forEach(function (value) {
                    selectedSimilarRecrut.push(value.name);
                });
                this.selectedRecrut = selectedSimilarRecrut;
            })
        })
    }

    ngAfterViewInit(): void {
        // Initialize form wizard
        this.wizard = new KTWizard(this.el.nativeElement, {
            startStep: 1,
            clickableSteps: true
        });

        // Validation before going to next page
        this.wizard.on('beforeNext', (wizardObj) => {
            // https://angular.io/guide/forms
            // https://angular.io/guide/form-validation

            // validate the form and use below function to stop the wizard's step
            // wizardObj.stop();
        });

        // Change event
        this.wizard.on('change', (wizard: any) => {
            setTimeout(() => {
                KTUtil.scrollTop();
            }, 500);
        });


    }

    ngOnDestroy() {
        this.wizard = undefined;
    }

    public addCompanyValue(): void {
        this.form.companyValues.push({
            name: '',
            description: '',
        });
    }

    public addResponsibility(): void {
        this.form.responsibility.push({
            name: '',
            description: '',
            importance: 0,
            timePercentage: ''
        });
    }

    public addSkill(): void {
        this.form.skillRequired.push({
            abilityName: '',
            abilityDescription: '',
            abilityLevel: ''
        });
    }

    public addTechnicalTesting(): void {
        this.form.technicalTesting.push({
            name: '',
            level: ''
        });
    }

    public addPsychologicalTesting(): void {
        this.form.psychologicalTesting.push({
            name: '',
            level: ''
        });
    }

    public addLanguage(): void {
        this.form.foreignLanguage.push({
            language: '',
            level: ''
        });
    }

    public addInternChannel(): void {
        this.form.internChannel.push({
            name: '',
            estimatedCost: 0,
            finalCost: 0,
            time: 0
        })
    }

    public addExternChannel(): void {
        this.form.externChannel.push({
            name: '',
            estimatedCost: 0,
            finalCost: 0,
            time: 0
        })
    }

    public addInternalTechnicalTest(): void {
        this.form.internalTechnicalTest.push({
            name: '',
            estimatedCost: 0,
            finalCost: 0,
            time: 0
        })
    }

    public addExternalTechnicalTest(): void {
        this.form.externalTechnicalTest.push({
            name: '',
            estimatedCost: 0,
            finalCost: 0,
            time: 0
        })
    }

    public addInternalPhysiologicalTest(): void {
        this.form.internalPhysiologicalTest.push({
            name: '',
            estimatedCost: 0,
            finalCost: 0,
            time: 0
        })
    }

    public addExternalPhysiologicalTest(): void {
        this.form.externalPhysiologicalTest.push({
            name: '',
            estimatedCost: 0,
            finalCost: 0,
            time: 0
        })
    }

    public addOtherTest(): void {
        this.form.otherTest.push({
            name: '',
            estimatedCost: 0,
            finalCost: 0,
            time: 0
        })
    }

    public addRecruiter(): void {
        this.form.recruiters.push({
            recruiterId: '',
            feeFixed: 0,
            feeEstimatedVariable: 0,
            feeEstimatedPerformed: 0,
            bonusFixed: 0,
            bonusEstimatedVariable: 0,
            bonusEstimatedPerformed: 0
        })
    }


    // --- Remove one group of fields from the form
    public removeCompanyValue(index: number): void {
        this.form.companyValues.splice(index, 1);
    }

    public removeResponsibility(index: number): void {
        this.form.responsibility.splice(index, 1);
    }

    public removeSkill(index: number): void {
        this.form.skillRequired.splice(index, 1);
    }

    public removeTechnicalTesting(index: number): void {
        this.form.technicalTesting.splice(index, 1);
    }

    public removePsychologicalTesting(index: number): void {
        this.form.psychologicalTesting.splice(index, 1);
    }

    public removeLanguage(index: number): void {
        this.form.foreignLanguage.splice(index, 1);
    }

    public removeInternChannel(index:number): void {
        this.form.internChannel.splice(index, 1);
    }

    public removeExternChannel(index:number): void {
        this.form.externChannel.splice(index, 1);
    }

    public removeInternalTechnicalTest(index:number): void {
        this.form.internalTechnicalTest.splice(index, 1);
    }

    public removeExternalTechnicalTest(index:number): void {
        this.form.externalTechnicalTest.splice(index, 1);
    }

    public removeInternalPhysiologicalTest(index:number): void {
        this.form.internalPhysiologicalTest.splice(index, 1);
    }

    public removeExternalPhysiologicalTest(index:number): void {
        this.form.externalPhysiologicalTest.splice(index, 1);
    }

    public removeOtherTest(index:number): void {
        this.form.otherTest.splice(index, 1);
    }

    public removeRecruiter(index:number): void {
        this.form.recruiters.splice(index, 1);
    }

}
